import {TransportIteraction} from './transport-iteraction';

export class Transport {
  transfers: TransportIteraction[];
}
